// extracted by mini-css-extract-plugin
export default {"container":"SocialMedia_container__qdcMo","iconsContainer":"SocialMedia_iconsContainer__PHUii","icon":"SocialMedia_icon__Pue5G","svgIcon":"SocialMedia_svgIcon__F2dPp"};